import React from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import { contentContainerId, focusStyle } from "../../constants";

function focusFirstFocusable(containerId: string) {
  const selector = `
    a[href],
    button:not([disabled]),
    textarea:not([disabled]),
    input:not([disabled]):not([type="hidden"]),
    select:not([disabled]),
    [tabindex]:not([tabindex="-1"])
  `;

  const container = document.getElementById(containerId);

  if (!container) return;

  const focusable = container.querySelectorAll<HTMLElement>(selector);

  if (focusable.length > 0) {
    focusable[0].focus();
  }
}

const SkipToContentButton = () => {
  const { t } = useTranslation();

  const onSkipToContent = () => focusFirstFocusable(contentContainerId);

  return (
    <button
      className={cx(
        "px-3 ml-2.5 h-[50px] cursor-auto focus:cursor-pointer flex-shrink",
        "text-xxs text-transparent focus:text-white hidden md:block",
        focusStyle
      )}
      onClick={onSkipToContent}
    >
      {t("common:nav.button.skipToContent")}
    </button>
  );
};

export default SkipToContentButton;
